export default __webpack_public_path__ + "static/media/0128.88deed90.jpg";